module.exports = __webpack_public_path__ + "static/media/logoAccueil.16a06277.png";